import { render } from "./list-courses.vue?vue&type=template&id=4130f2b0&ts=true"
import script from "./list-courses.vue?vue&type=script&lang=ts"
export * from "./list-courses.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__